import React from "react";
import * as ROUTE from "../../../routes";
import {
  UserSquare,
  Glass,
  SmsStar,
  Cup,
  MessageText,
  Logout,
  Edit,
  Bag,
} from "iconsax-react";

export const SideBarLinks = [
  { title: "پروفایل", link: ROUTE.ROUTE_MY_PROFILE, icon: <UserSquare /> },
  { title: "آزمایشگاه", link: ROUTE.ROUTE_MY_EXPERIMENT, icon: <Glass /> },
  {
    title: "گزارش فعالیت",
    link: ROUTE.ROUTE_MY_REPORT_LIST,
    icon: <SmsStar />,
  },
  // TODO: #Future feature
  // { title: "جوایز و امتیاز ها", link: ROUTE.ROUTE_MY_POINT, icon: <Cup /> },
  {
    title: "پیام ها",
    link: ROUTE.ROUTE_MY_MESSAGE_LIST,
    icon: <MessageText />,
  },
  { title: "سفارش ها", link: ROUTE.ROUTE_MY_FINANCIAL_LIST, icon: <Bag /> },
  { title: "دعوت از دوستان", link: ROUTE.ROUTE_REFERRAL, icon: <UserSquare /> },
  {
    title: "ویرایش اطلاعات",
    link: ROUTE.ROUTE_CHANGE_USER_INF,
    icon: <Edit />,
  },
  { title: "خروج", link: "exit", icon: <Logout />, exit: true },
];
